import { render, staticRenderFns } from "./GI.vue?vue&type=template&id=6e421bae&scoped=true"
import script from "./GI.vue?vue&type=script&lang=js"
export * from "./GI.vue?vue&type=script&lang=js"
import style0 from "./GI.vue?vue&type=style&index=0&id=6e421bae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e421bae",
  null
  
)

export default component.exports